var React = require('react');

function Expand (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_46590","data-name":"Group 46590","transform":"translate(-1079 19253) rotate(180)"},[React.createElement("rect",{"id":"Rectangle_42471","data-name":"Rectangle 42471","width":"16","height":"16","transform":"translate(-1079 19253) rotate(180)","fill":"none","key":0}),React.createElement("path",{"id":"Polygon_552","data-name":"Polygon 552","d":"M7.219.976a1,1,0,0,1,1.562,0l5.919,7.4A1,1,0,0,1,13.919,10H2.081A1,1,0,0,1,1.3,8.375Z","transform":"translate(-1095 19239)","key":1})]));
}

Expand.defaultProps = {"id":"expand","width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Expand;

Expand.default = Expand;
